{
	"title": "Atrybucja oprogramowania open source",
	"backTitle": "Wstecz"
}
